import { apiRequest } from './client';
import type { MeasurementRepository } from '../../application/ports/MeasurementRepository';
import type { Measurement, SensorMetric } from '../../domain/Measurement';

export class HttpMeasurementRepository implements MeasurementRepository {
  listForDevice(deviceId: string, limit = 50, filter: { metric?: SensorMetric; channel?: number } = {}) {
    const params = new URLSearchParams({ limit: String(limit) });
    if (filter.metric) params.set('metric', filter.metric);
    if (filter.channel) params.set('channel', String(filter.channel));
    return apiRequest<{ measurements: Measurement[] }>(`/devices/${deviceId}/measurements?${params}`);
  }

  listRecent(limit = 20) {
    return apiRequest<{ measurements: Measurement[] }>(`/measurements?limit=${limit}`);
  }
}
